import { Reducer, useReducer } from "react"
import { Book } from "../book/data-types"
import { searchBooks } from "../book/search"
import { useAuth } from "./auth"


type SearchState = {
    pending: boolean
    final: boolean
    books?: Array<Book>
    error?: string
    query: string
}

type UpdateFunction = (query: string, offset: number, limit: number, force?: boolean) => Promise<void>

export const useBookSearch = (): [SearchState, UpdateFunction] => {
    const user = useAuth()

    const [state, setState] = useReducer<Reducer<SearchState, Partial<SearchState>>>(
        (state, newState) => ({...state, ...newState}),
        {
            pending: false, 
            final: true,
            books: [],
            query: "",
        }
    )

    const update = async (query: string, offset: number, limit: number, force: boolean = false) => {
        if (force) {
            offset = 0
        }

        setState({ query, pending: true, final: false })
        try {
            const { data, error } = await searchBooks(query, offset, limit, user.token?.access)
            if (error != null) {
                setState({ error: error, pending: false })
                return
            }

            const usedIds = (state.books || []).map(el => el.id)
            const books = []
            for (const book of (data || [])) {
                if (!usedIds.includes(book.id)) {
                    books.push(book)
                }
            }
            
            if (!force) {
                if (!data?.length) {
                    setState({ final: true, pending: false })
                    return
                }

                setState({ books: [ ...(state.books || []), ...books], pending: false })
            } else {
                setState({ books, pending: false, final: !data?.length })
            }
        } catch (e) {
            setState({ error: e as string, pending: false })
        }
    }

    return [state, update]
}
